import { render, staticRenderFns } from "./general-info-tab.vue?vue&type=template&id=3021361d&scoped=true"
import script from "./general-info-tab.vue?vue&type=script&lang=js"
export * from "./general-info-tab.vue?vue&type=script&lang=js"
import style0 from "./general-info-tab.vue?vue&type=style&index=0&id=3021361d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3021361d",
  null
  
)

export default component.exports